import React from 'react';
import VehicleBrandLogo from './VehicleBrandLogo';

// Compact "vehicle of this order" chip with the model picture (zoom on hover), make logo as fallback
const OrderVehicleChip = ({ vehicle, label, testId = 'order-vehicle' }) => {
  if (!vehicle?.brand) return null;
  return (
    <div className="inline-flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-full pl-1 pr-3 py-1 text-xs text-gray-700" data-testid={testId}>
      <VehicleBrandLogo brand={vehicle.brand} model={vehicle.model} size={26} preferModel zoom testId={`${testId}-logo`} />
      <span className="truncate">
        {label && <span className="text-gray-400">{label} · </span>}
        <span className="font-medium">{vehicle.brand} {vehicle.model}</span>
        {vehicle.year ? <span className="text-gray-500"> ({vehicle.year})</span> : null}
        {vehicle.engine_name ? <span className="text-gray-500"> · {vehicle.engine_name}</span> : null}
        {vehicle.plate ? <span className="ml-1 font-mono bg-gray-900 text-white px-1.5 py-px rounded text-[10px]">{vehicle.plate}</span> : null}
      </span>
    </div>
  );
};

export default OrderVehicleChip;
